import React from "react";

import ExternalLink from "components/ExternalLink";
import Text from "components/Text";
import { useCurrentTenant } from "contexts/currentTenant";

import styles from "./TopLine.scss";

const TopLine = () => {
  const { full_name: tenantFullName, website_url: tenantURL } = useCurrentTenant();

  const tenantLink = tenantURL ? (
    <ExternalLink href={tenantURL}>{tenantFullName}</ExternalLink>
  ) : (
    tenantFullName
  );

  return (
    <div className={styles.container}>
      <span>
        <Text t="topline" /> {tenantLink}
      </span>
      <span>{tenantURL}</span>
    </div>
  );
};

export default TopLine;
